import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Schedule from "./pages/Schedule";
import RaceMap from "./pages/RaceMap";
import Registration from "./pages/Registration";
import Donate from "./pages/Donate";
import Sponsors from "./pages/Sponsors";
import Volunteer from "./pages/Volunteer";
import Gallery from "./pages/Gallery";
import Results from "./pages/Results";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import SponsorDonation from "./pages/SponsorDonation";
import DonationSuccess from "./pages/DonationSuccess";
import DonationCancel from "./pages/DonationCancel";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/race-map" element={<RaceMap />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/sponsors" element={<Sponsors />} />
          <Route path="/volunteer" element={<Volunteer />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/results" element={<Results />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/sponsor-donation" element={<SponsorDonation />} />
          <Route path="/donation/success" element={<DonationSuccess />} />
          <Route path="/donation/cancel" element={<DonationCancel />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
